/**
 * MetricsPanel.jsx
 * ================
 * Right sidebar displaying system metrics (CPU, RAM, Drive).
 * Hidden on mobile, visible as a fixed right panel on lg+.
 */

function DonutGauge({ value, label }) {
  const r = 24;
  const circ = 2 * Math.PI * r;
  const filled = (value / 100) * circ;
  const gap = circ - filled;
  const color = value < 60 ? '#4ade80' : value < 85 ? '#facc15' : '#f87171';
  return (
    <div className="flex flex-col items-center gap-1">
      <svg width="64" height="64" viewBox="0 0 64 64">
        <circle cx="32" cy="32" r={r} fill="none" stroke="#2a2a2a" strokeWidth="6"/>
        <circle
          cx="32" cy="32" r={r}
          fill="none"
          stroke={color}
          strokeWidth="6"
          strokeDasharray={`${filled} ${gap}`}
          strokeLinecap="round"
          transform="rotate(-90 32 32)"
        />
        <text x="32" y="37" textAnchor="middle" fill="white" fontSize="12" fontWeight="bold">
          {Math.round(value)}%
        </text>
      </svg>
      <span className="text-[#666] text-xs">{label}</span>
    </div>
  );
}

export default function MetricsPanel({ metrics }) {
  return (
    <aside className="hidden lg:flex bg-[#161616] border-l border-[#2a2a2a] w-48 shrink-0 flex-col p-4 gap-6 overflow-y-auto h-full">
      <div className="flex flex-col gap-4">
        <div className="text-[#CC5500] text-xs font-semibold uppercase tracking-widest">System</div>
        <div className="flex flex-col gap-5">
          <DonutGauge value={metrics.cpu} label="CPU" />
          <DonutGauge value={metrics.ram} label="RAM" />
          <DonutGauge value={metrics.drive} label="Drive" />
        </div>
      </div>
    </aside>
  );
}
